import { Image } from 'ol/layer'
import {ImageWMS } from 'ol/source'

import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';

function DataLayer(datalayer, geoserverLayer) {

    const source1 = process.env.REACT_APP_WMS_1;
    console.log("Layer information: "+datalayer+" "+geoserverLayer);
    let wmsSource = new TileWMS({
        url: source1,
        params: {'LAYERS': geoserverLayer},
        serverType: 'geoserver',
    });
    let dlayer = new TileLayer({source: wmsSource, name: datalayer, opacity: 0.5});

    return dlayer;
}



export default DataLayer;